import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, Shield } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="page-container pt-6 space-y-6">
      <Link to="/">
        <Button variant="ghost" className="mb-2">
          <ArrowLeft className="w-5 h-5 mr-2" />
          Volver
        </Button>
      </Link>

      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <Shield className="w-6 h-6 text-primary" />
        </div>
        <h1 className="heading-2">Política de Privacidad</h1>
      </div>

      <Card className="card-base">
        <CardContent className="p-6 space-y-6 text-sm leading-relaxed">
          <div className="bg-primary/5 rounded-xl p-4 text-center">
            <p className="font-medium text-primary">
              Tu información es tuya. Punto.
            </p>
          </div>

          <p className="text-muted-foreground">
            En Tu Prima respetamos tu información. Aquí te explicamos qué hacemos con ella, 
            sin letra pequeña ni términos confusos.
          </p>

          <div>
            <h3 className="font-semibold text-lg mb-2">¿Qué datos pedimos?</h3>
            <p className="text-muted-foreground">
              Solo solicitamos datos necesarios para:
            </p>
            <ul className="text-muted-foreground space-y-1 list-disc list-inside mt-2">
              <li>Registrarte en la plataforma</li>
              <li>Que puedas participar en los sorteos</li>
              <li>Entregarte los premios si ganas</li>
              <li>Contactarte si es necesario</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">¿Qué NO hacemos?</h3>
            <ul className="text-muted-foreground space-y-1 list-disc list-inside">
              <li><strong>No vendemos</strong> tus datos a terceros</li>
              <li><strong>No compartimos</strong> tu información con nadie que no necesite verla</li>
              <li><strong>No te enviamos</strong> spam ni publicidad de otros</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">¿Cómo protegemos tus datos?</h3>
            <p className="text-muted-foreground">
              Tu información se almacena de forma segura. Usamos medidas técnicas para 
              proteger tus datos de accesos no autorizados. Contraseñas encriptadas, 
              conexiones seguras, y todo lo que se necesita para mantenerte protegido.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">¿Puedo eliminar mi cuenta?</h3>
            <p className="text-muted-foreground">
              Sí. Puedes solicitar la eliminación de tu cuenta cuando lo desees. 
              Solo contáctanos y procesaremos tu solicitud. Tus datos serán eliminados 
              de forma permanente.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">¿Qué pasa si gano?</h3>
            <p className="text-muted-foreground">
              Si ganas un premio, necesitaremos verificar tu identidad para entregártelo. 
              Esto incluye tu documento y teléfono. Es por tu seguridad y para cumplir 
              con las regulaciones.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">Notificaciones</h3>
            <p className="text-muted-foreground">
              Te enviaremos notificaciones sobre tus compras, resultados de sorteos 
              y si ganas un premio. No te molestaremos con cosas innecesarias.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">Cookies y tecnología</h3>
            <p className="text-muted-foreground">
              Usamos cookies básicas para que la app funcione correctamente y recuerde 
              que ya iniciaste sesión. Nada más.
            </p>
          </div>

          <div className="bg-slate-50 rounded-xl p-4">
            <h3 className="font-semibold mb-2">En resumen:</h3>
            <ul className="text-muted-foreground space-y-1">
              <li>✅ Solo pedimos lo necesario</li>
              <li>✅ No vendemos ni compartimos tus datos</li>
              <li>✅ Tus datos están seguros</li>
              <li>✅ Puedes irte cuando quieras</li>
            </ul>
          </div>

          <div className="pt-4 border-t">
            <p className="text-xs text-muted-foreground text-center">
              ¿Tienes preguntas? Escríbenos a{' '}
              <a href="mailto:contacto@tuprima.com" className="text-primary hover:underline">
                contacto@tuprima.com
              </a>
            </p>
            <p className="text-xs text-muted-foreground text-center mt-2">
              Última actualización: Enero 2025
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
